import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  price: '₹9.80',
  strikedPricePostfix: '₹10.80',
  pricePostfix: 'GST',
  oldPrice: '₹1000 security deposit',
  strikedOldPricePostfix: '₹1500',
  savePrice: 'save ₹500'
}, getTestId('PriceDetailWidgetContainer'));